

window.addEventListener("load", function () {
    var swiper = new Swiper(".swiper-tiendo", {
        pagination: {
            el: ".swiper-tiendo-pagination",
        },
    });

});
